import { Stack, Image, FontIcon, Label, IStackTokens, ImageFit } from '@fluentui/react';
import React, { useContext } from 'react';
import styles from '../styles/collectie.module.scss';
import { NavLink } from 'react-router-dom';
import GlobalContext from '../_contexts/GlobalContext';

export interface IFooterComponentProps {
    UpdateStateExtern?: Function;
}

const Footer : React.FunctionComponent<IFooterComponentProps> = (props : IFooterComponentProps) => {
    const { OUT_EMAIL, WHATSAPP, FOOTER_TEXT, FOOTERHEADERBGCOLOR, FOOTERHEADERFONTCOLOR, GlobalImagesVersion } = useContext(GlobalContext);

    const footerTokens: IStackTokens = { childrenGap: '10' };
    
    return (   
        <div className={`${styles.divTable}`}>
            <div className={styles.divTableRow}>
                <div className={`${styles.divTableCell}`}>
                    <div className={styles.footerMain} style={{backgroundImage:`url('${process.env.PUBLIC_URL}/assets/container_footer_bg.webp?v=${GlobalImagesVersion}')`}}>
                        <Stack horizontal horizontalAlign='center' tokens={footerTokens} className={styles.footerContact} style={{backgroundColor: FOOTERHEADERBGCOLOR}}>
                            <div style={{display:"table"}}>
                                <div style={{display:"table-cell",verticalAlign:"middle"}}>
                                    <div>
                                        <Label style={{color:FOOTERHEADERFONTCOLOR}}>{FOOTER_TEXT} - Contact : </Label>
                                    </div>
                                </div>
                            </div>
                            <a href={`mailto:${OUT_EMAIL}`} className={styles.contactUrl} >
                            <FontIcon aria-label="Email" iconName="mail" className={styles.contactImage} 
                                    style={{color:FOOTERHEADERFONTCOLOR}}
                                    onClick={() => {window.open(`mailto:${OUT_EMAIL}`);}}/>
                            </a>
                            <Image className={styles.whatsappImage} 
                                style={{color:FOOTERHEADERFONTCOLOR}}
                                src={process.env.PUBLIC_URL + `/assets/whatsapp2.webp`} 
                                onClick={() => { window.open(WHATSAPP); }}
                                alt="" imageFit={ImageFit.contain} /> 
                        </Stack>
                        <Stack horizontal>
                            <Stack style={{whiteSpace:"nowrap", minWidth: "40%", paddingLeft:20}} >
                                
                                <span style={{color:"gray",fontSize:"large"}}>Informatie</span>
                                
                                {/* <NavLink to='/Algemene Voorwaarden' style={{textDecoration:"none",color:"darkgray",paddingTop:5}}>
                                    <span style={{cursor:"pointer"}} onClick={()=>{ }}>Algemene Voorwaarden</span>
                                </NavLink> */}
                                <NavLink to='/Privacybeleid' style={{textDecoration:"none",color:"darkgray",paddingTop:5}} onClick={() => {props.UpdateStateExtern("firstload",false); }}>
                                    <span style={{cursor:"pointer",fontSize:"smaller"}} onClick={()=>{ }}>Privacybeleid</span>
                                </NavLink>
                                <NavLink to='/Retourbeleid' style={{textDecoration:"none",color:"darkgray",paddingTop:5}} onClick={() => {props.UpdateStateExtern("firstload",false); }}>
                                    <span style={{cursor:"pointer",fontSize:"smaller"}} onClick={()=>{ }}>Retourbeleid</span>
                                </NavLink>
                                <NavLink to='/Over Ons' style={{textDecoration:"none",color:"darkgray",paddingTop:5}} onClick={() => {props.UpdateStateExtern("firstload",false); }}>
                                    <span style={{cursor:"pointer",fontSize:"smaller"}} onClick={()=>{ }}>Over Ons</span>
                                </NavLink>
                            </Stack>
                        </Stack>
                        
                        <Label className={styles.footerText}>
                            <br/>
                            <br/>
                        </Label>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;